export default (state, action) => {
    switch (action.type) {
      case "pageName" : return {currentPageName: action.payload};
      case "routePath": return {currentRoutePath: action.payload};
      default         : return state;
    }
};